
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface PropertiesAPIV2
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of properties and property layouts, and manage provider registrations.
 * @example content.getFeature('Properties')
 */
define([], () => {
	class PropertiesAPIV2 {

		/**
		 * @function PropertiesAPI#getPropertyLayoutList
		 * @description Returns the list of all property layouts.
		 * @return {Object[]}
		 */
		getPropertyLayoutList() {}

		/**
		 * @function PropertiesAPI#getPropertyList
		 * @description Returns the list of all properties.
		 * @return {Object[]}
		 */
		getPropertyList() {}

		/**
		 * @function PropertiesAPI#registerProvider
		 * @description Registers a provider as a properties provider.
		 * @param {PropertiesProviderAPI} provider Properties provider to register and contribute properties
		 */
		registerProvider() {}

		/**
		 * @function PropertiesAPI#deregisterProvider
		 * @description Deregisters a provider as a properties provider.
		 * @param {PropertiesProviderAPI} provider Properties provider to deregister and remove properties
		 */
		deregisterProvider() {}

		/**
		 * for debug usage
		 */
		getProviderPropertyNameList() {}

		/**
		 * @function PropertiesAPI#getPropertyValue
		 * @description Returns the property's value for a given property name
		 * @param {String} name Property name
		 */
		getPropertyValue() {}

		/**
		 * @function PropertiesAPI#setPropertyValue
		 * @description Sets a property's value for a given property name
		 * @param {String} name - property name
		 * @param {Object} value - property value
		 * @param {TransactionToken} [transactionToken] - transaction token
		 */
		setPropertyValue() {}
	}

	return PropertiesAPIV2;
});